import React from "react";
import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 30, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

/* Masked line-by-line kinetic reveal (hero signature moment) */
export const MaskLine = ({ children, delay = 0, className }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className || ""}`}
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.15, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`text-xs font-mono uppercase tracking-[0.25em] font-medium ${
      light ? "text-gold" : "text-amber-700"
    }`}
  >
    {children}
  </p>
);

export const SectionHeading = ({ eyebrow, title, subtitle, light = false }) => (
  <div className="max-w-2xl">
    <Reveal>
      <Eyebrow light={light}>{eyebrow}</Eyebrow>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.08] ${
          light ? "text-cream" : "text-ink"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base sm:text-lg font-light leading-relaxed ${light ? "text-cream/70" : "text-stone-600"}`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
